export const handleReportGenerationMessage = (obj, dispatch, createAction, types) => {
  switch (obj.type) {
    case 'UPDATE_GENERATE_REPORT':
      dispatch(createAction(types.REPORT_UPDATE_PROGRESS)(obj.progress))
      break

    case 'FINISH_GENERATE_REPORT':
      dispatch(createAction(types.REPORT_UPDATE_PROGRESS)(null))
      dispatch(
        createAction(types.REPORT_HISTORY_FINISHED)({
          filePath: obj.result,
          updatedAt: obj.date,
        }),
      )
      break

    case 'FAIL_GENERATE_REPORT':
      dispatch(createAction(types.CLEAR_DOWNLOADED_REPORT)())
      dispatch(
        createAction(types.SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Ocorreu um erro ao gerar o relatório. Procure um administrador.',
          feedbackTitle: '',
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'error',
          messageTimestamp: new Date().getTime(),
        }),
      )
      break

    default:
      // Tipo desconhecido, você pode adicionar um log ou ignorar
      break
  }
}
